export default __webpack_public_path__ + "static/media/o.10dd4b89.png";